<template>
  <div class="upload2">
    <div class="upload-head">
      <div class="back" @click="back()">
        <span class="el-icon-arrow-left"></span>
        返回
      </div>
      <div>编辑基础信息</div>
    </div>
    <div class="upload-main">
      <div class="part part1">
        <div class="thumb">
          <el-upload
            class="avatar-uploader"
            action="/api/APFAPI/UploadFile"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :on-error="handleError"
            accept=".jpg,.png,.jpeg"
          >
            <div
              v-if="form.iconUrl != ''"
              :style="'background-image:url(' + form.iconUrl + ')'"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </div>
      <div class="part part2">
        <el-form
          ref="form"
          :model="form"
          label-width="80px"
          label-position="top"
        >
          <el-form-item label="名称" v-if="type=='2'">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
           <el-form-item label="名称" v-else>
            <el-input v-model="form.modelName"></el-input>
          </el-form-item>
          <el-form-item label="描述">
            <el-input :rows="5"  type="textarea" v-model="form.description"></el-input>
          </el-form-item>
          <el-form-item label="类型">
            <el-select v-model="form.type" placeholder="请选择模型类型">
              <el-option label="fbx" value="fbx"></el-option>
              <el-option label="gltf" value="gltf"></el-option>
              <el-option label="obj" value="obj"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="part part3">
        <div class="status-block">
          <!-- <div class="top-line">
            <div></div>
            <el-button
              type="primary"
              size="small"
              icon="el-icon-view"
              @click="openEdit()"
              >view my model</el-button
            >
          </div>
           <el-divider></el-divider> -->
          <div class="mid-block">
            <div class="mid-line">
              <div>是否公开</div>
              <el-switch v-model="form.isPublic"> </el-switch>
            </div>
          </div>
          <el-divider></el-divider>
          <div class="bottom-block">
            <div>下载</div>
            <div class="btns">
              <div
                :class="{ btn: true, active: form.download == '1' }"
                @click="form.download = '1'"
              >
                不允许
              </div>
              <div
                :class="{ btn: true, active: form.download == '2' }"
                @click="form.download = '2'"
              >
                免费
              </div>
              <div
                :class="{ btn: true, active: form.download == '3' }"
                @click="form.download = '3'"
              >
                store
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="upload-foot">
      <div class="upload-foot-content">
        <el-button type="primary" class="save" @click="save()">保存</el-button>
      </div>
      <!-- <el-button type="warning" plain>发布</el-button> -->
    </div>
  </div>
</template>
<style>
.part1 .avatar-uploader .el-upload {
  width: 100%;
  height: 192px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.part1 .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.part1 .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100%;
  height: 100%;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 100%;
  height: 100%;
  display: block;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}
.part2 .el-form--label-top .el-form-item__label {
  padding: 0;
  line-height: 27px;
}
.part2 .el-form-item {
  margin-bottom: 10px;
}

.part3 .el-divider {
  margin: 15px 0;
}
</style>
<style scoped>
.upload2 {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: #f7f9fa;
  z-index: 10;
}
.upload-head {
  height: 48px;
  width: 100%;
  position: relative;
  text-align: center;
  color: #222;
  background-color: white;
  line-height: 48px;
}
.back {
  height: 100%;
  position: absolute;
  left: 10px;
  padding: 0 10px;
  cursor: pointer;
  font-size: 14px;
  color: #1caad9;
}
.back:hover {
  color: #1c88bb;
}
.upload-main {
  /* width: 100%; */
  position: relative;
  padding-top: 40px;
  margin: 0 40px;
  display: grid;
  grid-template-columns: 340px minmax(0, 2fr) 340px;
  grid-template-rows: auto auto auto;
  grid-column-gap: 24px;
  -moz-column-gap: 24px;
  column-gap: 24px;
  grid-row-gap: 24px;
  row-gap: 24px;
}
.part1 {
  max-width: 100%;
  flex-basis: 350px;
  grid-row: 1;
  grid-column: 1;
}
.part2 {
  flex: 1;
  max-height: none;
  grid-row: 1;
  grid-column: 2;
}
.part3 {
  grid-row: 1;
  grid-column: 3;
}

.status-block {
  display: flex;
  flex-direction: column;
  border: 1px solid #e7e7e7;
  padding: 16px;
  background-color: #fff;
  border-radius: 4px;
}

.mid-line {
  display: flex;
  justify-content: space-between;
  color: #222;
  font-size: 14px;
}

.bottom-block {
  font-size: 14px;
}

.btns {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
.btn {
  height: 40px;
  width: 96px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #1caad9;
  text-transform: capitalize;
  font-weight: 600;
  font-size: 12px;
  border: 1px solid #e7e7e7;
  cursor: pointer;
}
.btn.active,
.btn:hover {
  background-color: #e8f7fb;
  border-color: #1caad9;
  font-weight: 700;
  position: relative;
}

.upload-foot {
  height: 80px;
  width: 100%;
  position: fixed;
  bottom: 0;
}
.upload-foot-content {
  height: 100%;
  position: relative;
  border-top: 1px solid #ccc;
  margin: 0 40px;
}
.save {
  position: absolute;
  top: 18px;
  right: 0;
}
</style>
<script>
import https from "@/https.js";
// import MyHeader from "@/components/header.vue";
export default {
  name: "upload",
  props: {
    type:String, //0代表上传时新建，1代表模型的编辑，2代表场景的编辑
    res: Object,
  },
  components: {
    // MyHeader: MyHeader,
  },
  data() {
    return {
      form: {
        id: "",
        modelName: "",
        description: "",
        type: "fbx",
        modelUrl: "",
        iconUrl: "",
        tags: "",
        isPublic: false,
        download: "1",
      },
    };
  },
  
  created() {
    //this.init();
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.res.id == "") {
        this.form = {
          id: "",
          modelName: "",
          description: "",
          type: "fbx",
          modelUrl: this.res.modelUrl,
          iconUrl: "",
          tags: "",
          isPublic: false,
          download: "1",
        };
       
      } else {
        this.form = this.res;
      }
    },
    handleAvatarSuccess(res, file) {
      console.log(res);
      this.form.iconUrl = res.filePath;
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 5;
      return isLt2M;
    },
    handleError(err) {
      if (err.status == "401") {
        this.$router.push({ path: "/login" });
      }
    },
    back() {
      this.$parent.close();
    },
    save() {
      let url = "";
      if (this.type == "0") {
        url = "/AddModelDescript";
      } else if(this.type=='1') {
        url = "/UpdateModelDescript";
      }
      else{
         url = "/UpdateScene";
      }
      https.fetchPost(url, this.form).then((res) => {
        console.log(res.data);
        this.$parent.saveClose();
      });
    },
  },
};
</script>
